import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Label, Table } from 'reactstrap';

import { getDmxProfileById, updateDmxProfile, setDmxProfileChannels } from '../../store/actions';

function buildChannelRows(channelCount, existingChannels) {
  const byRelativeChannel = new Map((existingChannels || []).map((c) => [Number(c.relative_channel), c.function_name]));
  return Array.from({ length: channelCount }, (_, i) => ({
    relative_channel: i + 1,
    function_name: byRelativeChannel.get(i + 1) || '',
  }));
}

class UpdateDmxDeviceProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      profile: this.props.profile,
      channelCount: this.props.profile.channel_count,
      channels: buildChannelRows(this.props.profile.channel_count, []),
      popup: false,
      pop_msg: '',
      alertType: '',
      channelsPopup: false,
      channelsPopMsg: '',
      channelsAlertType: '',
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getDmxProfileById(this.state.user, this.state.profile.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.profileDetail && this.props.profileDetail !== prevProps.profileDetail) {
      this.setState({ channels: buildChannelRows(this.state.channelCount, this.props.profileDetail.channels) });
    }

    const { updateDmxProfileError, loadingUpdateDmxProfile, messageDmxProfile: msgUpdate } = this.props;
    if (loadingUpdateDmxProfile === false && prevProps.loadingUpdateDmxProfile === true) {
      if (updateDmxProfileError) {
        this.setState({ popup: true, pop_msg: updateDmxProfileError.message || 'Error al modificar el perfil', alertType: 'error' });
      } else if (msgUpdate) {
        this.setState({
          popup: true,
          pop_msg: 'Perfil modificado correctamente',
          alertType: 'correct',
          profile: { ...this.state.profile, channel_count: this.state.channelCount },
        });
      }
    }

    const { setDmxProfileChannelsError, loadingSetDmxProfileChannels } = this.props;
    if (loadingSetDmxProfileChannels === false && prevProps.loadingSetDmxProfileChannels === true) {
      if (setDmxProfileChannelsError) {
        this.setState({
          channelsPopup: true,
          channelsPopMsg: setDmxProfileChannelsError.message || 'Error al guardar la función de los canales',
          channelsAlertType: 'error',
        });
      } else {
        this.setState({ channelsPopup: true, channelsPopMsg: 'Función de canales guardada correctamente', channelsAlertType: 'correct' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmChannelsPopup() {
    this.setState({ channelsPopup: false });
  }

  handleValidSubmit(event, values) {
    const { user, profile } = this.state;
    values.id = profile.id;
    values.channel_count = Number(values.channel_count);
    values.token = user.token;
    this.setState({ channelCount: values.channel_count, channels: buildChannelRows(values.channel_count, this.state.channels) });
    this.props.updateDmxProfile(values);
  }

  onChannelCountChange(value) {
    const channelCount = Number(value) || 0;
    this.setState({ channelCount, channels: buildChannelRows(channelCount, this.state.channels) });
  }

  onChannelFunctionChange(relative_channel, function_name) {
    this.setState({
      channels: this.state.channels.map((c) => (c.relative_channel === relative_channel ? { ...c, function_name } : c)),
    });
  }

  saveChannels() {
    const { user, profile, channels } = this.state;
    this.props.setDmxProfileChannels({
      id: profile.id,
      channels: channels.filter((c) => c.function_name.trim()),
      token: user.token,
    });
  }

  render() {
    const { profile, channels } = this.state;
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Editar perfil DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileName">{this.props.t('Nombre')}</Label>
                  <AvField
                    value={profile.name}
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="profileName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileDeviceType">{this.props.t('Tipo')}</Label>
                  <AvInput
                    value={profile.device_type}
                    name="device_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="profileDeviceType"
                  >
                    <option value="LED">LED</option>
                    <option value="SPOTLIGHT">SPOTLIGHT</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileChannelCount">{this.props.t('Cantidad de canales')}</Label>
                  <AvField
                    value={profile.channel_count}
                    name="channel_count"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="profileChannelCount"
                    onChange={(e) => this.onChannelCountChange(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Button color="secondary" type="submit" className="buttonStatus mt-2">
                {this.props.t('Guardar cambios')}
              </Button>
            </AvForm>

            <hr />
            <CardTitle className="mb-4">{this.props.t('Función de cada canal')}</CardTitle>
            {profile.device_type === 'SPOTLIGHT' ? (
              <Alert color="info">
                {this.props.t(
                  'Si algún canal controla la intensidad/dimmer, su función debe escribirse exactamente como GENERAL_DIMMER (mayúsculas, sin espacios) — TPS busca ese nombre exacto para poder apagar el spotlight automáticamente. Cualquier otro texto (p. ej. "Intensidad") no será reconocido.',
                )}
              </Alert>
            ) : null}
            <Table className="table-centered table-nowrap mb-0">
              <thead>
                <tr>
                  <th>{this.props.t('Canal relativo')}</th>
                  <th>{this.props.t('Función')}</th>
                </tr>
              </thead>
              <tbody>
                {channels.map((c) => (
                  <tr key={c.relative_channel}>
                    <td>{c.relative_channel}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={this.props.t('Ej: PAN, TILT, COLOR, GENERAL_DIMMER...')}
                        value={c.function_name}
                        onChange={(e) => this.onChannelFunctionChange(c.relative_channel, e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Button color="secondary" className="buttonStatus mt-2" onClick={() => this.saveChannels()}>
              {this.props.t('Guardar función de canales')}
            </Button>

            {this.state.popup ? (
              <SweetAlert
                type={this.state.alertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
                title={this.state.pop_msg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
            {this.state.channelsPopup ? (
              <SweetAlert
                type={this.state.channelsAlertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.channelsAlertType === 'correct' ? 'success' : 'danger'}
                title={this.state.channelsPopMsg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmChannelsPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { profile: profileDetail } = state.getDmxProfileById;
  const { updateDmxProfileError, messageDmxProfile: msgUpdate, loadingUpdateDmxProfile } = state.updateDmxProfile;
  const { setDmxProfileChannelsError, loadingSetDmxProfileChannels } = state.setDmxProfileChannels;
  return {
    profileDetail,
    updateDmxProfileError,
    messageDmxProfile: msgUpdate,
    loadingUpdateDmxProfile,
    setDmxProfileChannelsError,
    loadingSetDmxProfileChannels,
  };
};

export default withRouter(
  connect(mapStateprops, { getDmxProfileById, updateDmxProfile, setDmxProfileChannels })(withNamespaces()(UpdateDmxDeviceProfileForm)),
);
